export default __webpack_public_path__ + "static/media/alex10.aa4910e2.jpg";